import React, { useEffect } from "react";
import { createPortal } from "react-dom";

interface ModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  width?: number | string;
  children: React.ReactNode;
  footer?: React.ReactNode;
  /** When true: no overlay/Esc/X close. */
  closeDisabled?: boolean;
  /** Header and footer stay put. Only the body scrolls, so the footer cannot slide past the card edge. */
  pinFooter?: boolean;
}

export function Modal({ open, onClose, title, width = 720, children, footer, closeDisabled = false, pinFooter = false }: ModalProps) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => { if (e.key === "Escape" && !closeDisabled) onClose(); };
    document.addEventListener("keydown", onKey);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = prevOverflow;
    };
  }, [open, onClose, closeDisabled]);

  if (!open) return null;

  return createPortal(
    <div className="modal-overlay" onClick={closeDisabled ? undefined : onClose}>
      <div
        className={pinFooter ? "modal-card modal-card--pin" : "modal-card"}
        style={{ maxWidth: width, width: "95vw" }}
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
      >
        <div className="modal-header">
          <h3>{title}</h3>
          <button type="button" className="modal-close" onClick={onClose} aria-label="Đóng" disabled={closeDisabled}>
            <span className="material-symbols-outlined">close</span>
          </button>
        </div>
        <div className={pinFooter ? "modal-body modal-body--scroll" : "modal-body"}>{children}</div>
        {footer && <div className="modal-footer">{footer}</div>}
      </div>
    </div>,
    document.body,
  );
}
